import { dispatcher, IEvent, ingenuity, IObject, SpineBase, toInt } from "@quest/base-core";
import {
  FreeGameReelPanelControllerBehavior,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
  SoundConstant,
} from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotEventConstants } from "@quest/slot-core";

export class FreeGameReelPanelControllerGame extends FreeGameReelPanelControllerBehavior {
  protected subscribeEvents(): void {
    dispatcher.on(eventDispatchers.STICKY_WILD_ADDED, this.gameFlowAfterSticky, this);
    dispatcher.on(SlotEventConstantsBehavior.UPDATE_REEL_SET, this.updateReelsets, this);
    dispatcher.on(eventDispatchers.HIDE_WILD_SYMBOL_ON_REEL, this.hideSymbol, this);
    super.subscribeEvents();
  }

  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.STICKY_WILD_ADDED, this.gameFlowAfterSticky, this);
    dispatcher.off(SlotEventConstantsBehavior.UPDATE_REEL_SET, this.updateReelsets, this);
    dispatcher.off(eventDispatchers.HIDE_WILD_SYMBOL_ON_REEL, this.hideSymbol, this);
  }
  /**
   * override to add sticky wild on view after reel stop
   * @param evt 
   */
  protected onSpinComplete(evt: any): void {
    this.reelView.setStopNow(false);
    this.reelView.getModel().quickSpin = false;
    const checkStickySym: number[][] = (ingenuity.parserModel as GameParserModel).getStickyWildData().wildPos;
    if (checkStickySym && checkStickySym.length) {
      dispatcher.fireEvent(eventDispatchers.ADD_STICKY_RANDOM_WILD);
    } else {
      this.gameFlowAfterSticky();
    }
  }
  /**
   * game flow after wild added to view
   */
  private gameFlowAfterSticky() {
    dispatcher.fireEvent(SlotEventConstants.FG_CHECK_FOR_WIN_AFTER_REEL_STOP);
    dispatcher.off(SlotEventConstants.FG_SHOW_ANTICIPATION, this.showAnticipation);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SET_IS_REEL_SPINNING, false);
    if (!this.model.getIsWin() && !(ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SEND_CLOSE_GAME_REQUEST);
    }
  }

  /**
   * hide symbol behind sicky symbol when sticky symbol appears on the reel
   * @param evt
   */
  private hideSymbol(evt: IEvent): void {
    let reelId: number = evt.data.reel;
    let col: number = evt.data.col;
    let sym = this.reelView.getSymbolByPos(reelId, col);
    const animSym: SpineBase = sym.getAnimation() as SpineBase;
    sym.getStatic().visible = false;
    animSym.visible = false;
  }

  /**
   * This method is use to update reelsets
   */
  private updateReelsets() {
    this.reelView.getModel().setReelsets([(ingenuity.parserModel as GameParserModel).getFreeSpinReel()]);
  }

  // Overrided to play scatter landing animation & sounds
  protected handleScatterLanding(value: IObject, evt: any): void {
    super.handleScatterLanding(value, evt);
    for (const element of (ingenuity.parserModel as GameParserModel).getLandingSoundOnReel()) {
      const value = element[evt];
      value && dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_LANDING_SOUNDS_FG, value);
    }
    dispatcher.fireEvent(SlotEventConstants.FG_SHOW_LANDINGANIMATION, [this.model.getReelGrid(), this.reelView, evt]);
  }
/**
 * play reel stop sound in freegame
 * @param evt 
 */
  protected onReelStopping(evt?: IEvent): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, {
      id: SoundConstant.REEL_STOP,
      key: SlotConstantsBehavior.SOUND_LIST_PRELOAD,
    });
    super.onReelStopping(evt);
  }

  /**
   * Method overrided
   */
  onReelStopped(evt: IEvent) {
    console.log("controller reel stop event--baseGame ", toInt(evt.toString()), evt);
    if (toInt(evt.toString()) === 4) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, {
        id: SoundConstant.ANTICIPATION_SOUND,
        key: SlotConstantsBehavior.SOUND_LIST_PRELOAD,
      });
    }
  }

  // Override to apply condition, we are playing anticipation only on 5th reel when retrigger trigger
  protected checkForAnticipation(symbolObj: any, listLength: number) {
    let i, j, k, n;
    let symbolCount = 0;
    let anticipation = [];
    let symbolFound = false;
    for (i = 0; i < this.reelView.getModel().numReels; i++) {
      this.reelView.getModel().anticipationSpin[i] = 0;
      if (symbolObj.aniticipationRunOnReel[i] > -1) {
        if (symbolObj.aniticipationRunOnReel[i] !== -1) {
          if (symbolCount >= symbolObj.symbolCount && symbolObj.aniticipationRunOnReel[i] !== -1) {
            if (ingenuity.configData.anticipationRunAfterFeature) {
              (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered() ? (anticipation[i] = 1) : (anticipation[i] = 0);
            } else {
              if (symbolCount >= symbolObj.symbolCount + 1) {
                anticipation[i] = 0;
              } else {
                anticipation[i] = 1;
              }
            }
          }
        }
      }
      for (j = 0; j < this.model.getReelGrid()[i].length; j++) {
        if (this.model.getReelGrid()[i][j] === symbolObj.symbolId) {
          symbolFound = true;
          break;
        }
      }
      if (symbolFound) {
        symbolCount++;
        symbolFound = false;
      }
    }
    this.anticipationList.push(anticipation);
    if (this.anticipationList.length === listLength) {
      for (k = 0; k < this.anticipationList.length; k++) {
        for (n = 0; n < this.anticipationList[k].length; n++) {
          if (this.anticipationList[k][n] === 1) {
            this.reelView.getModel().anticipationSpin[n] = 1;
          }
        }
      }
    }
    this.checkForlandingAnim(symbolObj, listLength);
  }
}
